import { Button, Checkbox } from "antd";
import styled, { css } from "styled-components";

export const StyledContainer = styled.div<{ $accent?: boolean }>`
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;

    ${({ $accent }) =>
        $accent
            ? css`
                  &::before {
                      position: absolute;
                      content: "";
                      left: -16px;
                      width: 3px;
                      height: 100%;
                      background-color: ${({ theme }) => theme.colors.warning};
                  }
              `
            : null}
`;

export const StyledMBCheckbox = styled(Checkbox)<{
    $isActive?: boolean;
    $pending?: boolean;
}>`
    ${({ theme, $pending }) => {
        const color = $pending ? theme.additionalTypographyColor : "#52c41a";

        return css`
            .ant-checkbox-checked .ant-checkbox-inner {
                background-color: ${color};
                border-color: ${color};
            }

            .ant-checkbox-checked::after {
                border-color: ${color};
            }
        `;
    }};

    width: 18px;
    height: 18px;

    .ant-checkbox-inner {
        width: 18px;
        height: 18px;
        border: 2px solid ${(props) => props.theme.checkboxBorder};

        background-color: ${(props) =>
            props.$isActive
                ? props.theme.secondaryBackgroundColor
                : props.theme.inactiveTabColor};
        opacity: ${(props) => (props.$isActive ? 1 : 0.2)};
    }

    .ant-checkbox-checked .ant-checkbox-inner::after {
        border: 2px solid #fff;
        border-top: none;
        border-left: none;
        transform: rotate(45deg) scale(1) translate(-50%, -50%);
    }
`;

export const StyledMBTaskLabel = styled(Button)<{
    $isActive: boolean;
    $isTaskDirty: boolean;
}>`
    padding: 0;
    height: auto;
    font-size: 16px;

    color: ${({ $isActive, $isTaskDirty, theme }) => {
        if ($isActive && $isTaskDirty) {
            return "#f16a1b";
        }

        if ($isActive) {
            return theme.primaryTypographyColor;
        }

        return theme.disabledTypographyColor;
    }} !important;
`;
